export const mapMobilePosition = (position: number): string => {
  const positions = {
    1: 'isTop',
    2: 'isCenter',
    3: 'isBottom'
  }

  return positions[position] || position[0]
}
